import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

const RATIO = 0.09;

export const IconInsuranceEuro = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "2.2px", ...props }, ref) => {
    // In this icon we use stroke instead of fill
    const currentStroke = isNumber(size) ? `${size * RATIO}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        {...props}
        ref={ref as any}
      >
        <path
          d="M11.8818 2.10742L11.9336 2.13086C13.3625 2.98277 17.3569 4.76641 18.9121 5.43359L18.9922 5.46875L19.0762 5.48926C19.1304 5.50294 19.1891 5.53149 19.2441 5.5791L19.2979 5.63379C19.3632 5.7101 19.4134 5.81367 19.4365 5.93457C19.4898 6.95658 19.5435 8.68163 19.4434 10.5244C19.3461 12.3137 19.108 14.126 18.6309 15.5059L18.5322 15.7764C17.0814 19.534 13.1442 21.3747 11.8848 21.8779L11.8711 21.8828L11.8584 21.8887L11.8047 21.9004H11.7979L11.7363 21.8877L11.7275 21.8838L11.4609 21.7764C10.0308 21.1763 6.64821 19.4298 5.19629 16.1328L5.05273 15.7861C4.50951 14.3782 4.24535 12.4431 4.14746 10.5371C4.0507 8.65263 4.12029 6.89528 4.19629 5.89844L4.19922 5.85645V5.81445C4.19926 5.76343 4.20969 5.74553 4.21191 5.74121C4.21639 5.73243 4.22954 5.70951 4.26855 5.67578C4.36412 5.59323 4.50097 5.52928 4.69238 5.45117L4.70801 5.44531C6.2632 4.78214 10.3083 2.98933 11.7246 2.12988L11.7256 2.13086C11.7768 2.10036 11.8294 2.09198 11.8818 2.10742Z"
          stroke="currentColor"
          strokeWidth={currentStroke}
        />
        <path
          d="M9.07556 11.767L9.06546 11.4392C9.06546 11.4119 9.07219 11.3641 9.08566 11.2959H8.5V10.2204H9.18663C9.36839 9.48984 9.73526 8.91628 10.2873 8.49977C10.846 8.08326 11.5461 7.875 12.3876 7.875C12.9597 7.875 13.5521 7.97742 14.1647 8.18226L13.781 9.32938C13.3502 9.14502 12.8924 9.05284 12.4077 9.05284C11.499 9.05284 10.9167 9.44204 10.6609 10.2204H12.741V11.3061H10.5599C10.5464 11.4153 10.5397 11.5041 10.5397 11.5724C10.5397 11.6338 10.5431 11.6987 10.5498 11.767H12.741V12.8424H10.6205C10.8426 13.6345 11.3812 14.0305 12.2361 14.0305C12.7208 14.0305 13.2963 13.8973 13.9628 13.6311L14.3667 14.6757C13.7204 15.0308 12.9934 15.2083 12.1856 15.2083C11.3845 15.2083 10.7147 14.9967 10.1762 14.5733C9.63766 14.15 9.29097 13.573 9.13614 12.8424H8.5V11.767H9.07556Z"
          fill="currentColor"
        />
      </svg>
    );
  }
);
